import {
    ArrowForwardOutlined,
    ArrowOutwardOutlined,
    ContentCopyOutlined,
    FileOpenOutlined,
    KeyboardArrowLeftOutlined,
    KeyboardArrowRightOutlined,
    VideocamOutlined,
} from '@mui/icons-material';
import { withRightToLeftMirroring } from './right-to-left-mirroring';

export { default as SvgIcon } from '@mui/material/SvgIcon';
export * from '@mui/material/SvgIcon';

export const ExternalIcon = withRightToLeftMirroring(ArrowOutwardOutlined);
export const CopyIcon = withRightToLeftMirroring(ContentCopyOutlined);
export const BackIcon = withRightToLeftMirroring(KeyboardArrowLeftOutlined);
export const ForwardIcon = withRightToLeftMirroring(KeyboardArrowRightOutlined);
export const InternalIcon = withRightToLeftMirroring(ArrowForwardOutlined);
export const VirtualIcon = withRightToLeftMirroring(VideocamOutlined);
export const OpenFileIcon = withRightToLeftMirroring(FileOpenOutlined);

// TODO: create a major Carotene upgrade that removes LeftIcon and RightIcon in favor of BackIcon and ForwardIcon
/**
 * @deprecated Use BackIcon instead.
 */
export const LeftIcon = BackIcon;
/**
 * @deprecated Use ForwardIcon instead.
 */
export const RightIcon = ForwardIcon;

export { default as DateIcon } from '@mui/icons-material/CalendarMonthOutlined';
export { default as AddIcon } from '@mui/icons-material/AddOutlined';
export { default as TriangleDownIcon } from '@mui/icons-material/ArrowDropDownOutlined';
export { default as TriangleUpIcon } from '@mui/icons-material/ArrowDropUpOutlined';
export { default as SelectedIcon } from '@mui/icons-material/CheckOutlined';
export { default as CloseIcon } from '@mui/icons-material/CloseOutlined';
export { default as DeleteIcon } from '@mui/icons-material/DeleteOutlined';
export { default as ShareIcon } from '@mui/icons-material/ShareOutlined';
export { default as InfoIcon } from '@mui/icons-material/InfoOutlined';

export { default as WarningIcon } from '@mui/icons-material/WarningAmberOutlined';
export { default as ErrorIcon } from '@mui/icons-material/ErrorOutlineOutlined';
export { default as SuccessIcon } from '@mui/icons-material/CheckCircleOutlineOutlined';
export { default as MenuIcon } from '@mui/icons-material/MoreVertOutlined';
export { default as DownIcon } from '@mui/icons-material/KeyboardArrowDownOutlined';
export { default as UpIcon } from '@mui/icons-material/KeyboardArrowUpOutlined';
export { default as SortAscendingIcon } from '@mui/icons-material/ArrowUpwardOutlined';
export { default as SortDescendingIcon } from '@mui/icons-material/ArrowDownwardOutlined';
export { default as SearchIcon } from '@mui/icons-material/SearchOutlined';
export { default as ShowIcon } from '@mui/icons-material/VisibilityOutlined';
export { default as HideIcon } from '@mui/icons-material/VisibilityOffOutlined';
export { default as EditIcon } from '@mui/icons-material/EditOutlined';

export { default as DistanceIcon } from '@mui/icons-material/NearMeOutlined';
export { default as LocationIcon } from '@mui/icons-material/LocationOnOutlined';
export { default as FilterIcon } from '@mui/icons-material/TuneOutlined';
export { default as UploadIcon } from '@mui/icons-material/FileUploadOutlined';

export { default as NavigationIcon } from '@mui/icons-material/MenuOutlined';
export { default as GatedIcon } from '@mui/icons-material/Lock';

export * from './custom';
export * from './admin';
